import { GridOptions } from "@ag-grid-community/core";
import { HumanizeCamelCasePipe } from "../../../pipes/humanize-camel-case.pipe";
import { WarehouseDialogComponent } from "../../logistic/warehouse/warehouse-dialog/warehouse-dialog.component";
import { DatePipe } from "@angular/common";

const humanizeCamelCasePipe = new HumanizeCamelCasePipe();
export const locationcolumnDefs: any = [
  {
    field: "LocationSummaryId",
    hide: true,
    resizable: false,
  },

  {
    field: "LocationId",
    hide: true,
    resizable: false,
  },
  {
    field: "WId",
    headerName: "Warehouse",
    resizable: false,
  },
  {
    field: "itemid",
    hide: true,
    resizable: false,
  },
  {
    field: "ItemName",
    hide: true,
    resizable: false,
  },
  {
    field: "WarehouseName",
    headerName: "Warehouse ",
    hide: true,
    //width: 120,
  },
  {
    field: "VendorItemName",
    headerName: "Vendor Item",
    //width: 120,
    hide:true,
  },
  {
    field: "Qty",
    headerName: "Qty",
    //width: 120,
    valueFormatter: (params) => {
      return Number(params.value)?.toLocaleString("en")
    }
  },
  {
    field: "TotalValue",
    headerName: "Total Value",
    valueFormatter: (params) => {
      return '$' + Number(params.value)?.toLocaleString("en")
    }
  },
  {
    field: "LastUpdate",
    headerName: "Last Updated",
    // width: 120,
    valueFormatter: (params) => {
      return params.value
      ? new DatePipe('en-US').transform(params.value, 'MM/dd/YYYY hh:mm a')
        : "";
    },
  },
];

const frameworkComponents = {
  warehouseDialogComponent: WarehouseDialogComponent,
};

export const gridOptionslocation: GridOptions = {
  rowModelType: "serverSide",
  suppressServerSideInfiniteScroll: false,
  suppressCopyRowsToClipboard: true,
  defaultColDef: {
    resizable: true,
    filterParams: {
      maxNumConditions : 1,
    },
    menuTabs: ["filterMenuTab"],
  },
  components: frameworkComponents,
};

// import moment from "moment";
// import { ActionsComponent } from "src/app/components/actions/actions.component";

//   export const LocationColumnDefs: any = [
//     {
//       field: "Name",
//       headerName: "Warehouse",
//       width: 180,
//     },
//     {
//       headerName: "Location",
//       field: "LocationCode",
//       width: 140,
//     },
//     {
//       field: "VendorItemName",
//       headerName: "Vendor Item",
//       width: 120,
//     },
//     {
//       field: "VendorName",
//       headerName: "Vendor Name",
//       width: 120,
//     },
//     {
//       field: "Qty",
//       headerName: "Qty",
//       width: 90,
//     },
//     {
//       field: "LastUpdate",
//       headerName: "Last Update",
//       valueFormatter: (params) => {
//         return params.value
//           ? moment(params.value).format("MM/DD/YYYY hh:mm A")
//           : "";
//       },
//       width: 120,
//     }
//   ];

//   const frameworkComponents = {
//     actionsComponent: ActionsComponent,
//   };

//   export const locationGridOptions: GridOptions = {
//     rowModelType: "serverSide",
//     suppressServerSideInfiniteScroll: false,
//     suppressCopyRowsToClipboard: true,
//     defaultColDef: {
//       resizable: true,
//       filterParams: {
//         maxNumConditions : 1,
//       },
//       menuTabs: ["filterMenuTab"],
//     },
//     components: frameworkComponents,
//   };
